import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-svg-glass",
  "use": "tc-svg-glass-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-svg-glass\">\n\t<path d=\"M12 14.4737C18 14.4737 20 10.2323 20 5H4C4 10.2323 6 14.4737 12 14.4737ZM12 14.4737V21.5789M12 21.5789L16 23H8L12 21.5789ZM5 9.73684H19\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol